<template>
  <div>
    <v-layout
      id="cv-table"
      v-resize="onResize"
      column
      justify-center
      text-center
    >
      <v-flex xs12 mb-5>
        <v-layout justify-space-between>
          <v-flex text-right mr-md-0 mr-3>
            <h3 class="font-weight-medium display-30">{{ cvHistoryTitle }}</h3>
            <span class="font-weight-medium display-24" >{{ cvHistoryTitle2 }}</span>
          </v-flex>
          <v-flex md4 sm4 xs6 align-self-center>
            <v-text-field
              v-model="search"
              prepend-inner-icon="icon-forma-1-copy-4"
              label="חיפוש"
              solo
              class="flex-grow-0"
              single-line
              hide-details
              outlined
              rounded
              dense
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-data-table
          :mobile-breakpoint="600"
          :headers="headers"
          :items="allCv"
          :options.sync="options"
          :class="{ mobile: isMobile }"
          :items-per-page="30"
          :search="search"
          :header-props="{ 'mdi-sort': 'md-arrow-drop-down' }"
          :footer-props="{
            showFirstLastPage: true,
            prevIcon: 'mdi-arrow-left',
            nextIcon: 'mdi-arrow-right',
            'items-per-page-text': 'הצג',
          }"
        >
          <template v-slot:item="props">
            <tr v-if="!isMobile" class="big-scr">
              <td>
                <ul>
                  <li>
                    <p
                      class="job-name display-18 primary--text mt-1 mb-2 font-weight-medium"
                    >
                      <nuxt-link
                        target="_blank"
                        :to="`${props.item.JobURL}`"
                        class="more-jobs primary--text pointer-underline"
                      >
                        {{ props.item.JobName }}
                      </nuxt-link>
                    </p>
                  </li>
                  <li class="mt-4">
                    <p class="mb-1 display-14">
                      <nuxt-link
                        :to="`${props.item.ExtraJobsURL}`"
                        class="more-jobs black--text no-underline"
                      >
                        {{ props.item.ExtraJobsText }} »
                      </nuxt-link>
                    </p>
                  </li>
                </ul>
              </td>
              <td class="text-center display-16">
                <span>{{ props.item.CompanyName }}</span>
              </td>
              <td class="text-center display-16">
                <span>{{ props.item.SentDateString }}</span>
              </td>
              <td
                class="text-center cv-file display-16"
                @click="
                  props.item.SentCV ? downloadCV(props.item.SentCV) : false
                "
              >
                <span :class="props.item.SentCV ? 'pointer-underline' : ''">
                  {{ props.item.CVFileName }}
                </span>
              </td>
            </tr>

            <!-- Mobile -->
            <tr v-else>
              <td>
                <ul class="flex-content">
                  <li class="flex-item" data-label="שם משרה">
                    <p
                      class="job-name display-16 primary--text d-flex mt-1 mb-0"
                    >
                      <nuxt-link
                        target="_blank"
                        :to="`${props.item.JobURL}`"
                        class="more-jobs primary--text pointer-underline text-right"
                      >
                        {{ props.item.JobName }}
                      </nuxt-link>
                    </p>
                    <nuxt-link
                      :to="`${props.item.ExtraJobsURL}`"
                      class="more-jobs caption black--text d-flex my-1"
                    >
                      {{ props.item.ExtraJobsText }} »
                    </nuxt-link>
                  </li>

                  <li class="flex-item2" data-label="שם חברה">
                    <span class="d-flex my-1">
                      {{ props.item.CompanyName }}
                    </span>
                  </li>
                  <li class="flex-item" data-label="תאריך שליחה">
                    <span class="d-flex my-1">
                      {{ props.item.SentDateString }}
                    </span>
                  </li>
                  <li
                    class="flex-item2"
                    data-label="קובץ קו''ח"
                    @click="
                      props.item.SentCV ? downloadCV(props.item.SentCV) : false
                    "
                  >
                    <span
                      class="d-flex my-1"
                      :class="props.item.SentCV ? 'pointer-underline' : ''"
                    >
                      {{ props.item.CVFileName }}
                    </span>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="item">
            {{ item.pageStart }} - {{ item.pageStop }} מ {{ item.itemsLength }}
          </template>
          <template slot="no-data">
            <div color="error" icon="warning" class>
              לא נמצאו שליחות קו"ח ב-90 יום האחרונים
            </div>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12 text-right mb-5>
        <small class="red--text display-16">
          * {{ t('titles.candidates.historyPageWarning') }}
        </small>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { fetchUserCV } from '@/lib/cvFiles.js';
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  props: {
    allCv: {
      type: Array,
      default: () => [],
      require: false,
    },
    sentCvHistoryCount: {
      type: Number,
      default: 0,
      require: false,
    },
  },
  data() {
    return {
      search: '',
      cvHistoryTitle: t('titles.candidates.cvHistoryTitle', {
        num: this.sentCvHistoryCount,
      }),
      cvHistoryTitle2: t('titles.candidates.cvHistoryTitle2'),
      showComponent: true,
      itemsCount: '',
      options: {},
      isMobile: false,
      sentCvHistory: null,
      headers: [
        {
          text: 'שם משרה',
          align: 'center',
          sortable: false,
          value: 'JobName',
          class: ['col-hdr display-18 '],
        },
        {
          text: 'שם חברה',
          value: 'companyName',
          class: ['col-hdr-r display-18 text-center'],
          sortable: false,
        },
        {
          text: 'תאריך שליחה',
          value: 'SentDateString',
          class: ['col-hdr-r display-18 text-center'],
        },
        {
          text: 'קובץ קו"ח',
          value: 'CVFileName',
          class: ['col-hdr-r display-18 text-center'],
          sortable: false,
        },
      ],
    };
  },

  computed: {
    pages() {
      if (this.options.rowsPerPage == null || this.options.totalItems == null) {
        return 0;
      }
      return Math.ceil(this.options.totalItems / this.options.rowsPerPage);
    },
  },

  mounted() {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  },

  methods: {
    async downloadCV(fileCode) {
      await fetchUserCV(fileCode, this.$axios);
    },
    onResize() {
      if (window.innerWidth < 600) this.isMobile = true;
      else this.isMobile = false;
    },
    changeSort(column) {
      if (this.options.sortBy === column) {
        this.options.descending = !this.options.descending;
      } else {
        this.options.sortBy = column;
        this.options.descending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#cv-table ul {
  padding-right: 20px;
  list-style-type: none;
}

#cv-table table.v-table thead th {
  border-collapse: separate;
  border-spacing: 0 5px;
}

.tr.big-scr td .job-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

#cv-table .col-hdr {
  max-width: 100%;
  padding: 0 5px !important;
}

#cv-table .col-hdr-r {
  max-width: 100%;
  text-align: center;
  padding: 10px 5px !important;
}

#cv-table tr.big-scr,
tr.big-scr td {
  max-width: 200px !important;
  padding: 10px 5px !important;
}

#cv-table td,
#cv-table tr {
  border: 1px solid $light-gray;
}

.sort-menu {
  background: #fff;
}
.v-application--is-rtl .v-data-footer__pagination {
  direction: ltr;
}
@media only screen and (min-width: 600px) {
  #cv-table .col-hdr {
    max-width: 320px;
  }

  #cv-table .col-hdr-r {
    max-width: 100px;
  }

  #cv-table tr,
  td {
    max-width: 200px !important;
  }
}

.mobile {
  color: #333;
}

@media screen and (max-width: 600px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-right: 6px solid #b5b5b5;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-right: 6px solid #e4e4e4;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding: 7px 0;
    text-align: right;
    display: block;
    color: #999;
    font-weight: normal;
    text-decoration: underline;
  }

  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }

  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}

.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  width: 60%;
  font-weight: 400
}

.flex-item2 {
  width: 40%;
  font-weight: 400
}

@media screen and (max-width: 600px) {
  .flex-item {
    width: 100%;
    font-weight: 400
  }

  .flex-item2 {
    width: 100%;
    font-weight: 400
  }
}
</style>
